/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Localcms_Celestial_Resources_TitleInputs */

const en_localcms_celestial_resources_title = /** @type {(inputs: Localcms_Celestial_Resources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Localcms_Celestial_Resources_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_celestial_resources_title = /** @type {((inputs?: Localcms_Celestial_Resources_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Celestial_Resources_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_celestial_resources_title(inputs)
});